import { Button, Col, Divider, Dropdown, Menu, Row } from 'antd'
import { CaretDownOutlined, ArrowRightOutlined } from '@ant-design/icons';
import React from 'react'
import { Doughnut } from 'react-chartjs-2';
import { useEffect, useState } from 'react'
import Cookies from 'js-cookie';
import api from '../utils/apiRoutes';
import GlobalLoading from '../Containers/GlobalLoading';

let softColors = [
  { main: "#a6cee3", hover: "#8ec0d2", background: "#d5ebf2" },
  { main: "#1f78b4", hover: "#175b8e", background: "#cbe0f5" },
  { main: "#b2df8a", hover: "#8ec68c", background: "#e9f5db" },
  { main: "#33a02c", hover: "#267822", background: "#c1e0cb" },
  { main: "#fb9a99", hover: "#e5807d", background: "#fcdedc" },
  { main: "#e31a1c", hover: "#c7191a", background: "#f5c1c2" },
  { main: "#fdbf6f", hover: "#d6a45b", background: "#f9e3cc" },
  { main: "#ff7f00", hover: "#e66800", background: "#ffdbb3" },
  { main: "#cab2d6", hover: "#a18dbf", background: "#e9d8ec" },
  { main: "#6a3d9a", hover: "#532c73", background: "#d5cce9" },
  { main: "#ffff99", hover: "#e6e57f", background: "#ffffcc" },
  { main: "#b15928", hover: "#8e4821", background: "#e0a487" },
  { main: "#8dd3c7", hover: "#72b8ad", background: "#d2f0eb" },
  { main: "#ffffb3", hover: "#e6e57f", background: "#ffffcc" },
  { main: "#bebada", hover: "#a29fa6", background: "#e8e8ec" },
  { main: "#fb8072", hover: "#e66a5a", background: "#fcdedc" },
  { main: "#80b1d3", hover: "#6593b9", background: "#dce6f1" },
  { main: "#fdb462", hover: "#e3814a", background: "#fcdedc" },
  { main: "#b3de69", hover: "#91c257", background: "#eaf4da" },
  { main: "#fccde5", hover: "#e894c2", background: "#fcebf5" }
];


function ClaimType() {

  const [filters, setFilters] = useState({ date: '', location: '' });
  const [stats, set_stats] = useState([]);
  const [loading, setLoading] = useState(false);

  const onClickDate = (e) => {
    // console.log(e.key, 'here');
    setFilters({ ...filters, date: e.key });
  };
  const onClickLocation = (e) => {
    // console.log(e.key, 'here');
    setFilters({ ...filters, location: e.key });
  };

  useEffect(() => {
    const headers = { 'Authorization': `Bearer ${Cookies.get('token_medical_auth')}` }
    setLoading(true);

    api.insuranceStats.getInsuranceStats({}, headers, filters).then(res => {
      const sortedStats = [...res.insuranceStats].sort((a, b) => {
        if (a.type < b.type) return -1;
        if (a.type > b.type) return 1;
        return 0;
      });
      const sortedRes = { ...res, insuranceStats: sortedStats };
      set_stats((sortedRes || []));
      // console.log(res, "HERE in claim amount");
      while (softColors.length < res.insuranceStats.length) {
        softColors = [...softColors, ...softColors];
      }
      setLoading(false);
    }).catch(err => {
      // console.log(err);
      setLoading(false);
    })

  }, [filters])

  const CircularSVG = ({ percent, color, type }) => {
    const radius = 25;
    const strokeWidth = 5;
    const circumference = 2 * Math.PI * radius;
  
    const dashOffset = ((100 - percent) / 100) * circumference;
  
    return (
      <svg width={`${type ? (radius*2)+28 : radius*2}`} height={radius * 2} viewBox={`0 0 ${radius * 2} ${radius * 2}`}>
        <circle
          cx={radius}
          cy={radius}
          r={radius - strokeWidth / 2}
          fill="none"
          stroke="#E6E7E6"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={radius}
          cy={radius}
          r={radius - strokeWidth / 2}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          strokeLinecap="round"
          transform={`rotate(-90 ${radius} ${radius})`}
        />
        <text x="50%" y="50%" textAnchor="middle" fill="#000" fontSize="12px" dominantBaseline="middle">
          {percent}%
        </text>
      </svg>
    );
  }

  const menu = (
    <Menu
      onClick={onClickDate}
      items={[
        {
          key: '',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              All dates
            </a>
          ),
        },
        {
          key: 'Today',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              Today
            </a>
          ),
        },
        {
          key: 'This week',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.aliyun.com" onClick={(e) => { e.preventDefault() }}>
              This week
            </a>
          ),
        },
        {
          key: 'This month',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.luohanacademy.com" onClick={(e) => { e.preventDefault() }}>
              This month
            </a>
          ),
        },
      ]}
    />
  );

  const menuLocation = (
    <Menu
      onClick={onClickLocation}
      items={[
        {
          key: '',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              All locations
            </a>
          ),

        },
        {
          key: 'Delhi',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              Delhi
            </a>
          ),

        },
        {
          key: 'Mumbai',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              Mumbai
            </a>
          ),

        }
      ]}
    />
  );


  const options = {
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        bodyFont: {
          size: 22
        },
        padding: 15,
        titleAlign: 'center',
        // bodyAlign: 'center',
        titleMarginBottom: 12,
        titleFont: {
          size: 18
        },
        boxPadding: 10,
        position: 'nearest',
        callbacks: {
          label: function(context) {
            return `₹${context.formattedValue}`
          },
          title: function(context) {
            return context[0].label
          }
        }
      }
    },
    cutout: 180,
  }
  // console.warn("HERE===> ",{data:stats?.insuranceStats?.map(item=>item.type.slice(0,5)),background:softColors.slice(0,stats?.insuranceStats?.length || 0)})
  const cash = stats?.insuranceStats?.find(item => item.type === 'Cash');
  const cashIndex = stats?.insuranceStats?.findIndex(item => item.type === 'Cash');
  if (cashIndex && cashIndex !== -1) {
    // console.log({ color: 'grenw' })
    softColors[cashIndex].main = '#FF9900';
    softColors[cashIndex].hover = '#c87d0c';
  }

  const data = {
    labels: stats?.insuranceStats?.map(item => {
      if (item.type.length > 30) return `${item.type.slice(0, 30)}.. `
      else return item.type;
    }),
    datasets: [
      {

        data: stats?.insuranceStats?.map(item => item.totalBookings),
        backgroundColor: softColors.map(item => item.main),
        borderColor: softColors.map(item => item.main),
        // hoverBackgroundColor: [
        //     '#2B44FF',
        //     '#00BC8B',
        // ],
        borderWidth: 0,
        pointBorderWidth: 1,
        pointHoverRadius: 5,
      },
    ],
  };


  if (loading) return <GlobalLoading />
  return (
    <div className="claim-amount-container claim-type-container">
      {/* <h5>Insurance Type</h5> */}
      {/* {console.warn("HERE=> ",stats)} */}
      <div className="claim-amount-box">

        <Row>
          <Col className="indicators" span={14}>
            <h3>Insurance Provider Ratio</h3>
            {/* <div className="indicators-container">
              <i className="color green" />
              Cashless
            </div>
            <div className="indicators-container">
              <i className="color blue" />
              Reimbursement
            </div> */}
          </Col>
          <Col className="drop-btns-container" span={10}>

            <Row justify='end'>
              <Col style={{ marginRight: 5 }}>
                <Dropdown overlay={menu} placement="bottom" getPopupContainer={trigger => trigger.parentElement}>
                  <Button>{filters.date === '' ? 'Date' : filters.date} <CaretDownOutlined /></Button>
                </Dropdown>
              </Col>
              {/* <Col>
                <Dropdown overlay={menuLocation} placement="bottom">
                  <Button>{filters.location === '' ? 'Location' : filters.location} <CaretDownOutlined /></Button>
                </Dropdown>
              </Col> */}
            </Row>

          </Col>
        </Row>
        {/* <Divider /> */}
        <Row>
          <Col span={24} type='flex' align='middle'>
            <Doughnut className="stats-donut insurance-data-chart" options={options} data={data}/>
          </Col>
          <Col className="stats-data-container" span={24}>
            {stats?.insuranceStats?.map((item,index) => (
              <div key={index} className='insurance-stats-info'>
                <div className='stats-data'>
                  <CircularSVG color={softColors[index]?.main} percent={stats?.total>0 ? Math.round((item.totalBookings/stats?.total)*100) : 0} type={item.type==='Cash'} />
                  <p>{item.type}</p>
                </div>
                <ArrowRightOutlined style={{color:'#A19F9F', fontSize:'1rem'}}/>
              </div>
            ))}
            {/* <a>View Details</a> */}
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default ClaimType